/**
 * comparar.js — Módulo de comparação de veículos.
 *
 * Permite ao usuário selecionar até 2 veículos para comparação.
 * Exibe uma barra flutuante fixa com os veículos selecionados
 * e redireciona para a página de comparação dedicada.
 */

const MAX_COMPARE = 2;

/** IDs dos veículos selecionados para comparação */
let _selecionados = [];
/** Dados cacheados dos veículos (img, name, price, slug) */
let _dadosCarros = {};

// ── Helpers ───────────────────────────────────────────────────

const $ = id => document.getElementById(id);

// ── Estado ────────────────────────────────────────────────────

export function toggleComparar(carId, carData = null) {
  const idx = _selecionados.indexOf(carId);
  if (idx !== -1) {
    _selecionados.splice(idx, 1);
  } else {
    if (_selecionados.length >= MAX_COMPARE) return;
    _selecionados.push(carId);
    if (carData) {
      _dadosCarros[carId] = carData;
    }
  }
  atualizarUI();
}

export function removerComparar(carId) {
  _selecionados = _selecionados.filter(id => id !== carId);
  atualizarUI();
}

// ── UI Updates ────────────────────────────────────────────────

function atualizarUI() {
  atualizarBotoeCards();
  atualizarBarraFlutuante();
}

function atualizarBotoeCards() {
  document.querySelectorAll('.btn-comparar').forEach(btn => {
    const id = btn.dataset.carId;
    const ativo = _selecionados.includes(id);
    btn.classList.toggle('comparar-ativo', ativo);
    
    const label = btn.querySelector('.comparar-label');
    if (label) label.textContent = ativo ? 'Selecionado' : 'Comparar';

    if (_selecionados.length >= MAX_COMPARE && !ativo) {
      btn.classList.add('comparar-disabled');
    } else {
      btn.classList.remove('comparar-disabled');
    }
  });
}

function getVeiculoData(id) {
  return _dadosCarros[id];
}

function atualizarBarraFlutuante() {
  const barra = $('compare-bar');
  if (!barra) return;

  if (_selecionados.length === 0) {
    barra.hidden = true;
    return;
  }

  barra.hidden = false;

  const container = $('compare-bar-items');
  if (!container) return;

  container.innerHTML = _selecionados.map(id => {
    const car = getVeiculoData(id);
    if (!car) return '';
    return `
      <div class="compare-bar-item">
        <img src="${car.img}" alt="${car.name}" class="compare-bar-thumb" />
        <div class="compare-bar-info">
          <span class="compare-bar-name">${car.name}</span>
          <span class="compare-bar-price">${car.price}</span>
        </div>
        <button class="compare-bar-remove" data-car-id="${id}" aria-label="Remover ${car.name}">×</button>
      </div>
    `;
  }).join('');

  // Listeners de remoção
  container.querySelectorAll('.compare-bar-remove').forEach(btn => {
    btn.addEventListener('click', () => removerComparar(btn.dataset.carId));
  });

  // Botão comparar
  const btnComparar = $('compare-bar-btn');
  if (btnComparar) {
    btnComparar.disabled = _selecionados.length < 2;
  }
}

// ── Navegar para página de comparação ─────────────────────────

function irParaComparacao() {
  if (_selecionados.length < 2) return;

  const carA = getVeiculoData(_selecionados[0]);
  const carB = getVeiculoData(_selecionados[1]);
  if (!carA || !carB) return;

  const slugA = carA.slug || carA.id;
  const slugB = carB.slug || carB.id;

  window.location.href = `/comparar?v1=${encodeURIComponent(slugA)}&v2=${encodeURIComponent(slugB)}`;
}

// ── Inicialização ─────────────────────────────────────────────

export function initComparar() {
  const barra = document.createElement('div');
  barra.id = 'compare-bar';
  barra.className = 'compare-bar';
  barra.hidden = true;
  barra.innerHTML = `
    <div class="container compare-bar-inner">
      <div class="compare-bar-items" id="compare-bar-items"></div>
      <button class="btn btn-primary btn-sm" id="compare-bar-btn" disabled>
        Comparar
      </button>
    </div>
  `;
  document.body.appendChild(barra);

  $('compare-bar-btn').addEventListener('click', irParaComparacao);
}
